/**
 * Created by shiyonggao on 2019/1/28.
 */

const MD5 = require("md5.js");

import Vue from "vue";
import Vuex from "vuex";
import VueI18n from "vue-i18n";
import { Base64 } from "js-base64";
import Lodash from "lodash";
import Jquery from "jquery";
import Helper from "../helper/autoload";
import Moment from "moment";
import routerMaps from "../config/router";
import qs from "qs";
const Config = require("../config/config");

import rootActions from "./actions";
import rootMutations from "./mutations";
import rootGetters from "./getters";
import modules from "./modules/autoload";

const locale = "zh-CN";

Vue.use(Vuex);
Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: locale,
    messages: require("../language/lang_config")
});

/**
 * md5算法
 * @param str
 * @param hex
 * @returns {*}
 */
const md5Fn = (str, hex = "hex") => {
    return new MD5()["update"](str)["digest"](hex);
};

const routeFn = (routeName, data, blank = false) => {
    let urlParams = Helper.helper.getUrlParams();
    data = Object.assign({}, urlParams, data);
    Helper.helper.route(routeName, data, blank);
};

const getNoRoleRoute = () => {
    let temp = {};
    for (let key in routerMaps) {
        if (!routerMaps[key]["role"]) {
            temp[key] = routerMaps[key];
        }
    }
    return temp;
};
console.log(Config, 64)
const state = {
    $i18n: i18n,
    $md5: md5Fn,
    $base64: Base64,
    $page: "index",
    $config: Config,
    $lodash: Lodash,
    $jquery: Jquery,
    $helper: Helper,
    $moment: Moment,
    $loading: true,
    $vue: null,
    $s_title: "ODP5发行平台",
    $title: "ODP5发行平台 欢迎您！",
    $route: routeFn,
    $routerMaps: Object.assign({}, getNoRoleRoute()),
    $routerMapsDefined: routerMaps,
    $gameList: [],
    $gameAdminList: [],
    $activeGameCode: "lotr",
    $activeGameInfo: {},
    $userInfo: "",
    /** 1，发行配置   2，业务发行 **/
    $projectType: 1,
    $loadingPrivate: false,
    $isaccess: true,
    /** 无权限禁用选择切换功能 **/
    $selectDisabledStatus: false,
    $selectPlaceholder: "请选择",
    $iframeHeight: 400,
    $roles: [],
    $isAdmin: 0,
    $isGameAdmin: 0,
    $jumpProjectTypeRoute1: "",
    $jumpProjectTypeRoute2: "",
    $showProjectTypeRoute2: true,
    $showProjectTypeRoute1: true
};

const actions = rootActions;
const mutations = rootMutations;
const getters = rootGetters;
const store = new Vuex.Store({
    modules,
    state,
    actions,
    mutations,
    getters
});

export default store;



// WEBPACK FOOTER //
// ./website/store/app.js